import { registerHandledErrors } from '@/shared/api/client'
import { CLIENT_API_ENDPOINTS } from '@/shared/lib'

import type { IHandledErrorRule } from '@/shared/api/client'

const UNAUTHORIZED = 401

/**
 * 다른 기기에서 다시 로그인하면 remember-me가 무효가 되어 401이 온다. 결제 준비 페이지가 재로그인으로 보낸다.
 * 경로 포함 매칭이라 차량 상세(/car/macar/{id}) 401도 함께 빠진다.
 */
export const CAR_HANDLED_ERRORS: Record<string, IHandledErrorRule> = {
  [CLIENT_API_ENDPOINTS.CAR.MACAR]: {
    statuses: [UNAUTHORIZED],
  },
}

registerHandledErrors(CAR_HANDLED_ERRORS)
